import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';
import { IdSchema } from '../../../resource-base/baseSchemas';

export enum ProcessAreaToolAssociationPropertyValidation {
    TOOL = 'TOOL',
}

export const ProcessAreaToolAssociationResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z
        .literal(ResourceType.PROCESS_AREA_TOOL_ASSOCIATION)
        .default(ResourceType.PROCESS_AREA_TOOL_ASSOCIATION),
    tool: IdSchema,
});
export const ProcessAreaToolAssociationMutationResourceSchema = getMutationSchema(
    ProcessAreaToolAssociationResourceSchema
);

export type ProcessAreaToolAssociationResource = z.infer<typeof ProcessAreaToolAssociationResourceSchema>;

export const defaultProcessAreaToolAssociationResource: ProcessAreaToolAssociationResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.PROCESS_AREA_TOOL_ASSOCIATION,
    tool: '',
};

export function useProcessAreaToolAssociationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-area-tool-association',
            ResourceType.PROCESS_AREA_TOOL_ASSOCIATION,
            ProcessAreaToolAssociationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area-tool-association',
            ResourceType.PROCESS_AREA_TOOL_ASSOCIATION,
            ProcessAreaToolAssociationResourceSchema
        ),
    };
}
